function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { useSlots as _useSlots, useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderSlot as _renderSlot, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue";
import { ElInput, ElAutocomplete } from 'element-plus';
import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/autocomplete/style/css'

import { Field } from 'vee-validate';
import { useAttrs, computed } from 'vue';
import axios from '@/js/lib/helper/axios';
import { hankaku as toHankaku } from '@/js/lib/helper/hankaku';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ITextField',
    props: /*@__PURE__*/ _mergeModels({
        name: {},
        type: {
            default: undefined
        },
        title: {
            default: ''
        },
        size: {
            default: ''
        },
        formatter: {
            type: Function,
            default: undefined
        },
        parser: {
            type: Function,
            default: undefined
        },
        hankaku: {
            type: Boolean
        },
        apiPath: {
            default: ''
        },
        bankName: {
            default: ''
        },
        width: {
            default: ''
        },
        max: {
            default: undefined
        },
        allowClear: {
            type: Boolean
        },
        autocomplete: {
            default: undefined
        }
    }, {
        "modelValue": {},
        "modelModifiers": {}
    }),
    emits: [
        "update:modelValue"
    ],
    setup (__props) {
        const props = __props;
        const attrs = useAttrs();
        const slots = _useSlots();
        const innerValue = _useModel(__props, "modelValue");
        const activeFormatter = computed(()=>{
            var _props_formatter;
            return (_props_formatter = props.formatter) !== null && _props_formatter !== void 0 ? _props_formatter : props.hankaku ? toHankaku : undefined;
        });
        const activeParser = computed(()=>{
            var _props_parser;
            return (_props_parser = props.parser) !== null && _props_parser !== void 0 ? _props_parser : props.hankaku ? toHankaku : undefined;
        });
        const querySearch = (q, cb)=>_async_to_generator(function*() {
                const res = yield axios.get(props.apiPath, {
                    params: props.apiPath === '/api/bank/branch' ? {
                        q,
                        searchShop: true,
                        bankName: props.bankName
                    } : {
                        q
                    }
                });
                const data = res.data ? res.data.split('\n').map((value)=>{
                    return {
                        value
                    };
                }) : [];
                cb(data);
                return data;
            })();
        return (_ctx, _cache)=>{
            return _openBlock(), _createBlock(_unref(Field), {
                modelValue: innerValue.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>innerValue.value = $event),
                name: __props.name
            }, {
                default: _withCtx(({ field, handleChange, errors })=>[
                        _createElementVNode("div", null, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(__props.title ? 'label' : 'div'), {
                                class: _normalizeClass(_ctx.$style.label),
                                style: _normalizeStyle(__props.width ? {
                                    maxWidth: `${__props.width}px`
                                } : {})
                            }, {
                                default: _withCtx(()=>[
                                        __props.title ? (_openBlock(), _createElementBlock("p", {
                                            key: 0,
                                            class: _normalizeClass([
                                                _ctx.$style.title,
                                                errors[0] && _ctx.$style.hasError
                                            ])
                                        }, _toDisplayString(__props.title), 3)) : _createCommentVNode("", true),
                                        _cache[2] || (_cache[2] = _createTextVNode()),
                                        __props.apiPath ? (_openBlock(), _createBlock(_unref(ElAutocomplete), _mergeProps({
                                            key: 1,
                                            "model-value": field.value,
                                            "fetch-suggestions": querySearch,
                                            class: [
                                                errors[0] && 'error'
                                            ]
                                        }, _unref(attrs), {
                                            "onUpdate:modelValue": handleChange
                                        }), null, 16, [
                                            "model-value",
                                            "class",
                                            "onUpdate:modelValue"
                                        ])) : (_openBlock(), _createBlock(_unref(ElInput), _mergeProps({
                                            key: 2,
                                            name: __props.name,
                                            "model-value": field.value,
                                            type: __props.type,
                                            autocomplete: __props.autocomplete,
                                            "show-password": __props.type === 'password',
                                            formatter: activeFormatter.value,
                                            parser: activeParser.value,
                                            class: [
                                                __props.size === 'medium' && _ctx.$style.medium,
                                                errors[0] && 'error'
                                            ]
                                        }, _unref(attrs), {
                                            "onUpdate:modelValue": handleChange
                                        }), null, 16, [
                                            "name",
                                            "model-value",
                                            "type",
                                            "autocomplete",
                                            "show-password",
                                            "formatter",
                                            "parser",
                                            "class",
                                            "onUpdate:modelValue"
                                        ])),
                                        _cache[3] || (_cache[3] = _createTextVNode()),
                                        __props.allowClear && field.value ? (_openBlock(), _createElementBlock("i", {
                                            key: 3,
                                            class: _normalizeClass([
                                                _ctx.$style.clear,
                                                'icon-cross1'
                                            ]),
                                            onClick: _cache[0] || (_cache[0] = ($event)=>innerValue.value = '')
                                        }, null, 2)) : _createCommentVNode("", true)
                                    ]),
                                _: 2
                            }, 1032, [
                                "class",
                                "style"
                            ])),
                            _cache[5] || (_cache[5] = _createTextVNode()),
                            _createElementVNode("div", {
                                class: _normalizeClass(_ctx.$style.errorWrap)
                            }, [
                                __props.type === 'textarea' ? (_openBlock(), _createElementBlock(_Fragment, {
                                    key: 0
                                }, [
                                    errors[0] && !(__props.max && typeof innerValue.value === 'string' && innerValue.value.length > __props.max) ? (_openBlock(), _createElementBlock("p", {
                                        key: 0,
                                        class: _normalizeClass(_ctx.$style.error)
                                    }, _toDisplayString(errors[0]), 3)) : slots.help ? (_openBlock(), _createElementBlock("p", {
                                        key: 1,
                                        class: _normalizeClass(_ctx.$style.help)
                                    }, [
                                        _renderSlot(_ctx.$slots, "help")
                                    ], 2)) : _createCommentVNode("", true),
                                    _cache[4] || (_cache[4] = _createTextVNode()),
                                    __props.max && typeof innerValue.value === 'string' ? (_openBlock(), _createElementBlock("p", {
                                        key: 2,
                                        class: _normalizeClass([
                                            _ctx.$style.counter,
                                            innerValue.value.length > __props.max && _ctx.$style.error
                                        ])
                                    }, _toDisplayString(innerValue.value.length) + " / " + _toDisplayString(__props.max), 3)) : _createCommentVNode("", true)
                                ], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                                    key: 1
                                }, [
                                    errors[0] ? (_openBlock(), _createElementBlock("p", {
                                        key: 0,
                                        class: _normalizeClass(_ctx.$style.error)
                                    }, _toDisplayString(errors[0]), 3)) : slots.help ? (_openBlock(), _createElementBlock("p", {
                                        key: 1,
                                        class: _normalizeClass(_ctx.$style.help)
                                    }, [
                                        _renderSlot(_ctx.$slots, "help")
                                    ], 2)) : _createCommentVNode("", true)
                                ], 64))
                            ], 2)
                        ])
                    ]),
                _: 3
            }, 8, [
                "modelValue",
                "name"
            ]);
        };
    }
});
